import React, { useCallback, useEffect, useState } from "react";
import { Edit, SimpleForm, useEditContext, useNotify } from "react-admin";

// Types
import { CreateUsersProps } from "../../types/users";
import { FormMode } from "../../types/form-mode.enum";
import { User } from "../../types/organizations";

// Providers
import { organizationsProvider } from "../../providers/organizations";
import { usersProvider } from "../../providers/users";

// Components
import { UserForm } from "./UserForm";
import EditToolbar from "../EditToolbar";
import ResetPasswordButton from "./ResetPasswordButton";

const Aside: React.FC = () => {
  const { record: data } = useEditContext<User>();
  const [initialData, setInitialData] = useState<CreateUsersProps>({
    first_name: "",
    last_name: "",
    email: "",
    members: [],
    organizations: [],
  });

  const fetchData = useCallback(async () => {
    if (!data) {
      return;
    }

    const response = await organizationsProvider.getMany();

    if (response) {
      setInitialData((oldValue) => ({
        ...oldValue,
        organizations: response.filter((item) => {
          return !data?.members?.map((i: { organization: { id: string } }) => i.organization.id).includes(item.id);
        }),
      }));
    }
  }, [data]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {data && (
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "1em 1em 0" }}>
          <ResetPasswordButton userId={data.id} onReset={usersProvider.resetPassword} />
        </div>
      )}
      <SimpleForm
        mode="onBlur"
        reValidateMode="onBlur"
        defaultValues={initialData}
        toolbar={<EditToolbar name="user" resource="users" />}
      >
        <UserForm mode={FormMode.EDIT} />
      </SimpleForm>
    </>
  );
};

export const EditComponent: React.FC = () => {
  const notify = useNotify();

  const onSuccess = () => {
    notify(`User updated successfully`, { type: "success" });
  };

  const onError = (error: any) => {
    notify(error.message, { type: "error" });
  };

  return (
    <Edit mutationMode="pessimistic" mutationOptions={{ onSuccess, onError }}>
      <Aside />
    </Edit>
  );
};
